// removed by extract-text-webpack-plugin
module.exports = {"container":"_2dvznerFwQW-Q2fzDsta_2","title":"_1zjpRs96buBTMJp0xuXKLq","buttons":"_2Cku5d9jc9VaBx43BDEkoH","cancelButton":"_21KG2TwdnX4OruaSnBKU0w"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Root/ApolloError/UnauthorizedSession/Authorize/styles.css
// module id = 1235
// module chunks = 85